export enum TypeOptionEnum {
  VISIT = 'VISIT',
  TRANSFER = 'TRANSFER',
  OTHER = 'OTHER',
}
